import { CLEAR_SELECTED_USER, PeopleActions, SET_SELECTED_USER } from '@Actions/peopleActions';

import { IUserExtension } from '@ClientModels/userExtension';

interface IPeopleState {
  selectedUser: IUserExtension | null;
}

export const defaultState: IPeopleState = {
  selectedUser: null
};

export function peopleReducer(state = defaultState, action: PeopleActions): IPeopleState {
  switch (action.type) {
    case SET_SELECTED_USER: {
      return { ...state, selectedUser: action.payload };
    }

    case CLEAR_SELECTED_USER: {
      return { ...state, selectedUser: null };
    }

    default:
      return state;
  }
}
